var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unified-panel-outer-wrap",style:(_vm.styles),attrs:{"id":_vm.side}},[_vm._t("panel",function(){return [_c(_vm.currentPanel,_vm._b({tag:"component"},'component',_vm.currentPanelProperties,false))]}),_vm._v(" "),_c('div',{staticClass:"unified-panel-footer"},[_c('div',{staticClass:"panel-collapse",class:{
                left: _vm.side === 'left',
                right: _vm.side === 'right',
                hidden: !_vm.show,
            },on:{"click":_vm.toggle}}),_vm._v(" "),_c('div',{staticClass:"drag",on:{"mousedown":_vm.dragHandler}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }